// extracted by mini-css-extract-plugin
export default {"weight-heavy":"Header-module__weight-heavy__OX6O2"};